import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button } from "react-bootstrap";
import Select from "react-select";
import { Formik } from "formik";
import "../../../../assets/css/cms/Permission.css";
import { AiTwotoneStar } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../../../utils/loader";
import Alert from "@mui/material/Alert";
import { useSelector, useDispatch } from "react-redux";
import { FiChevronRight } from "react-icons/fi";
import "../../../../assets/css/common/breadcrumb.css";
// import CommonModal from "../../../utils/commonModal";
import DesktopDatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import Box from '@mui/material/Box'
import FeedbackList from "./feedbackList";
import {
    getProductFilter, getFeedbackList, clearFeedbackSuccess,
    getFeedbackType, getFeedbackUnMappedList, clearMessage,
} from "../../../../../store/slices/cp_feedback";
import { format } from 'date-fns';

function FeedbackTool() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [appliedFilters,setAppliedFilters] =useState(false);
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [product, setProduct]=useState({});
    const [feedbackType,setFeedbackType]=useState({});
    const [mappedStatus, setMappedStatus] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [debounceState, setDebounceState] = useState(false);
    const { productFilterData, feedbackTypeFilterData, message, putFeedbackDetailError,
        feedbackListData, feedbackListUnMappedData, putFeedbackDetailData,
        postFeedbackListUnMappedError, postFeedbackListError, putFeedbackMappedStatusError } = useSelector((state) => {
            return state?.cmsFeedback
        })
    const { user } = useSelector((state) => { return state?.userData})

    useEffect(() => {
        dispatch(getFeedbackType({ filter_type: "feedback_type" }))
    }, [])  

    useEffect(() => {
        if (message) {
            setTimeout(() => {
                if ((putFeedbackDetailData) && message) {
                    dispatch(clearMessage());
                    navigate(`/cms/tools`)
                } else {
                    dispatch(clearMessage());
                }
            }, 5000);
        }
    }, [message]);
    return (
        <div className='block_user'>
            <h4>Map Tools Feedbacks</h4>
            <div className={"custom_breadcrumb"}>
                <ul className={"custom_breadcrumb_ul"}>
                    <li className={"custom_breadcrumb_list"}>
                        <Link to="/cms/">
                            <a className={"sub_nan_anchor"}>Home</a>
                        </Link>
                    </li>
                    <li className={"custom_breadcrumb_list"}>
                        <span>
                            <FiChevronRight />
                        </span>
                    </li>
                    <li className={`${"custom_breadcrumb_list"} ${"custom_breadcrumb_list_active"}`}>
                        Map Tools Feedbacks
                    </li>
                </ul>
            </div>

            <div className={"notification_popup"}>
                {message && (
                    <Alert severity={postFeedbackListError|| postFeedbackListUnMappedError || putFeedbackDetailError || putFeedbackMappedStatusError ? `error` : `success`}>
                        {" "}
                        {message}
                    </Alert>
                )}
            </div>

            <div className={"examfilter"}>
                <h4>Filter Tools Feedback</h4>
                <Formik
                    initialValues={{}}
                    enableReinitialize
                    validate={(values) => {
                        let errors = {};
                        if (!values?.product)
                            errors.product = "This field is required."
                        return errors
                    }}
                // onSubmit={(values) => {
                //     props.submit(values);
                // }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleSubmit,
                        handleBlur,
                        setFieldValue,
                    }) => {
                        
                        const handleInputChange = (e, name) => {
                            let params = {};
                            const value = e;
                            setIsMenuOpen(true);
                            params.filter_type = name;
                            params.query = value;
                            let inDebounce = debounceState;
                            clearTimeout(inDebounce);
                            inDebounce = setTimeout(() => {
                                if (name === "product")
                                    dispatch(getProductFilter(params))
                            }, 1000);
                            setDebounceState(inDebounce);
                        }

                        const handleApply=()=>{
                            const params = new FormData();
                                params.product_id=values?.product?.id || values?.product
                                params.date_from = dateFrom;
                                params.date_to = dateTo;
                                if(values.feedback_type)
                                    params.feedback_type = values?.feedback_type?.name.toLowerCase();
                                
                            if(values?.product){
                                setAppliedFilters(params);
                            }
                        }
                        const handleClear = () => {
                            setFieldValue("product", "");
                            setDateFrom(null);
                            setDateTo(null);
                            setFeedbackType("");
                            setFieldValue("feedback_type", "");
                            setAppliedFilters(false);
                            dispatch(clearFeedbackSuccess());
                        }

                        return (
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='feedbacktool_product_label'>Product<sup className='icon_star'>*</sup></Form.Label>
                                            <Select
                                                name="product"
                                                value={values?.product}
                                                onBlur={() => {
                                                    handleBlur({
                                                        target: { name: "product" },
                                                    });
                                                }}
                                                onChange={(obj) => {setFieldValue("product", obj);setProduct(obj);}}
                                                onInputChange={(e) => {
                                                    if (e) {
                                                        setIsMenuOpen(true);
                                                        handleInputChange(e, "product")
                                                    }
                                                    else
                                                        setIsMenuOpen(false);
                                                }}
                                                options={productFilterData || []}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => option.id}
                                                isClearable={false}
                                                isSearchable={true}
                                                menuIsOpen={isMenuOpen}
                                            />
                                            {errors.product && touched.product && (
                                                <div className="error">{errors.product}</div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3 date_input" controlId="startDate">
                                            <Form.Label> Date From</Form.Label>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DesktopDatePicker
                                                    label="Custom input"
                                                    value={dateFrom}
                                                    onChange={(sValue) => {
                                                        if (sValue) {
                                                            setDateFrom(sValue.toISOString());
                                                        } else {
                                                            setDateFrom(null);
                                                        }
                                                    }}
                                                    renderInput={({ inputRef, inputProps, InputProps,
                                                    }) => (
                                                        <Box
                                                            sx={{ display: "flex", alignItems: "center" }}
                                                        >
                                                            <Form.Control
                                                                ref={inputRef}
                                                                {...inputProps}
                                                                className={"input_pd"}
                                                                placeholder='dd-mm-yyyy'
                                                                value={dateFrom ? format(new Date(dateFrom), 'dd-MM-yyyy') : ''}

                                                            />
                                                            {InputProps?.endAdornment}
                                                            {dateFrom && (
                                                                <Button
                                                                    variant="link"
                                                                    onClick={() => setDateFrom(null)}
                                                                    className={"cross-button position-absolute"}
                                                                >
                                                                    &#x2716;
                                                                </Button>
                                                            )}
                                                        </Box>
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3 date_input" controlId="startDate">
                                            <Form.Label>Date To</Form.Label>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DesktopDatePicker
                                                    label="Custom input"
                                                    value={dateTo}
                                                    minDate={new Date(dateFrom)}
                                                    onChange={(eValue) => {
                                                        setDateTo(eValue.toISOString());
                                                    }}
                                                    renderInput={({
                                                        inputRef,
                                                        inputProps,
                                                        InputProps,
                                                    }) => (
                                                        <Box
                                                            sx={{ display: "flex", alignItems: "center" }}
                                                        >
                                                            <Form.Control
                                                                ref={inputRef}
                                                                {...inputProps}
                                                                className={"input_pd"}
                                                                placeholder='dd-mm-yyyy'
                                                                value={dateTo ? format(new Date(dateTo), 'dd-MM-yyyy') : ''}
                                                            />
                                                            {InputProps?.endAdornment}
                                                            {dateTo && (
                                                                <Button
                                                                    variant="link"
                                                                    onClick={() => setDateTo(null)}
                                                                    className={"cross-button position-absolute"}
                                                                >
                                                                    &#x2716;
                                                                </Button>
                                                            )}
                                                        </Box>
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Feedback Type </Form.Label>
                                            <Select
                                                name="feedback_type"
                                                value={values?.feedback_type}
                                                onChange={(obj) => {setFieldValue("feedback_type", obj);setFeedbackType(obj);}}
                                                options={feedbackTypeFilterData || []}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => option.id}
                                                isClearable={false}
                                                isSearchable={true}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className='d-flex justify-content-space-between'>
                                            <button className={"exam_button rounded-pill"} type="submit"
                                            onClick={handleApply}
                                            >
                                                Apply
                                            </button>
                                            <button className={"exam_button rounded-pill"} type="button"
                                                onClick={handleClear}
                                            >
                                                Clear Filter
                                            </button>
                                        </div>
                                    </Col>

                                </Row>
                            </Form>
                        );
                    }
                    }
                </Formik>
            </div>

            {/* ********************************Table/List Data****************************** */}
            {/* { feedbackListUnMappedData && */}
            {appliedFilters &&<>
            <div className={"exam_table_box"} style={{ marginTop: "30px" }}>
                <FeedbackList
                    heading="New Feedbacks"
                    appliedFilters={appliedFilters}
                    addButtons={false}
                    user={user?.data}
                    isModarate={0}
                    feedbackState={(params)=>getFeedbackUnMappedList(params)}
                />
            </div>
          
            <div className={"exam_table_box"} style={{ marginTop: "30px" }}>
                <FeedbackList
                    heading="Selected Feedbacks"
                    addButtons={true}
                    appliedFilters={appliedFilters}
                    user={user?.data}
                    isModarate={1}
                    feedbackState={(params)=>getFeedbackList(params)}
                />
            </div>
</>}
            {/* } */}
        </div>

    )
}

export default FeedbackTool